import React from 'react'
import {BiErrorCircle} from 'react-icons/bi'

function Error({error}) {
  return (
    <div className='error'><BiErrorCircle/> {error}</div>
  )
}

export default Error